import * as React from 'react'

import { default as MuiDrawer, DrawerProps as MuiDrawerProps } from '@material-ui/core/Drawer'

export type DrawerProps = MuiDrawerProps

const Drawer: React.FC<DrawerProps> = React.forwardRef((props, ref) => <MuiDrawer ref={ref} {...props} />)

export { Drawer }
